export default __webpack_public_path__ + "static/media/spinner.50cd3412.gif";